import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { useUserDetails } from "@sdk/react";
import { OverlayContext, OverlayTheme, OverlayType } from "@temp/components";
import { filterNotEmptyArrayItems } from "@utils/misc";
import React from "react";
import { useIntl } from "react-intl";
import { AddressForm } from "../AddressForm";
import { AddressGridSelector } from "../AddressGridSelector";
import * as S from "./styles";
import { checkoutMessages } from "../../../../intl";
/**
 * Address form used in checkout.
 */

var CheckoutAddress = function CheckoutAddress(_ref) {
  var checkoutAddress = _ref.checkoutAddress,
      email = _ref.email,
      selectedUserAddressId = _ref.selectedUserAddressId,
      userAddresses = _ref.userAddresses,
      countries = _ref.countries,
      userId = _ref.userId,
      formRef = _ref.formRef,
      formId = _ref.formId,
      setShippingAddress = _ref.setShippingAddress,
      errors = _ref.errors,
      newAddressFormId = _ref.newAddressFormId;

  var _useUserDetails = useUserDetails(),
      user = _useUserDetails.data;

  var intl = useIntl();
  return React.createElement(S.Section, null, !user && React.createElement(OverlayContext.Consumer, null, function (overlay) {
    return React.createElement(S.LoginButton, null, intl.formatMessage(_defineProperty({
      defaultMessage: "Already have an account?",
      "id": "@next.components.organisms.CheckoutAddress.CheckoutAddress.3997369764"
    }, "id", "@next.components.organisms.CheckoutAddress.CheckoutAddress.3997369764")), React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return overlay.show(OverlayType.login, OverlayTheme.modal);
      }
    }, intl.formatMessage(_defineProperty({
      defaultMessage: "Sign in",
      "id": "@next.components.organisms.CheckoutAddress.CheckoutAddress.1405865627"
    }, "id", "@next.components.organisms.CheckoutAddress.CheckoutAddress.1405865627"))), intl.formatMessage(_defineProperty({
      defaultMessage: "or continue as guest.",
      "id": "@next.components.organisms.CheckoutAddress.CheckoutAddress.3030560766"
    }, "id", "@next.components.organisms.CheckoutAddress.CheckoutAddress.3030560766")));
  }), React.createElement(S.Title, {
    "data-cy": "checkoutPageSubtitle"
  }, intl.formatMessage(checkoutMessages.shippingAddress)), userAddresses ? React.createElement(AddressGridSelector, {
    formId: formId,
    formRef: formRef,
    addresses: userAddresses,
    selectedAddressId: selectedUserAddressId,
    countriesOptions: countries === null || countries === void 0 ? void 0 : countries.filter(filterNotEmptyArrayItems),
    userId: userId,
    errors: errors,
    onSelect: function onSelect(address, id) {
      return setShippingAddress(address, undefined, id);
    },
    newAddressFormId: newAddressFormId
  }) : React.createElement(AddressForm, {
    formId: formId,
    formRef: formRef,
    countriesOptions: countries === null || countries === void 0 ? void 0 : countries.filter(filterNotEmptyArrayItems),
    address: _objectSpread({}, checkoutAddress, {
      email: email
    }),
    handleSubmit: function handleSubmit(address) {
      return setShippingAddress(address, address === null || address === void 0 ? void 0 : address.email);
    },
    includeEmail: true,
    backendValidationErrors: errors
  }));
};

export { CheckoutAddress };